// src/admin/components/SectionList.jsx
import React from 'react';
import '../styles/SectionSettings.css';

const LABEL = {
  nav:     'Navigation',
  main:    'Main',
  service: 'Service',
  how:     'How It Works',
  about:   'About',
  gallery: 'Gallery',
  contact: 'Contact',
  footer:  'Footer',
};

function Placeholder({ toIdx, order, onMoveItem, setHoverIdx }) {
  return (
    <li
      className="section-placeholder"
      onDragOver={e => e.preventDefault()}
      onDrop={e => {
        e.preventDefault();
        const key = e.dataTransfer.getData('text/plain');
        onMoveItem(order.indexOf(key), toIdx);
        setHoverIdx(null);
      }}
    />
  );
}

export default function SectionList({
  order,
  visible,
  toggle,
  onMoveItem,
  hoverIdx,
  setHoverIdx,
}) {
  return (
    <ul className="section-list">
      {order.map((key, idx) => (
        <React.Fragment key={key}>
          {hoverIdx === idx && (
            <Placeholder
              toIdx={idx}
              order={order}
              onMoveItem={onMoveItem}
              setHoverIdx={setHoverIdx}
            />
          )}
          <li
            className="section-item"
            draggable
            onDragStart={e => {
              e.dataTransfer.setData('text/plain', key);
              e.currentTarget.style.opacity = '.4';
            }}
            onDragEnd={e => {
              e.currentTarget.style.opacity = '1';
              setHoverIdx(null);
            }}
            onDragOver={e => {
              e.preventDefault();
              setHoverIdx(idx);
            }}
            onDrop={e => {
              e.preventDefault();
              const fromKey = e.dataTransfer.getData('text/plain');
              onMoveItem(order.indexOf(fromKey), idx);
              setHoverIdx(null);
            }}
          >
            <input
              type="checkbox"
              checked={visible.includes(key)}
              onChange={() => toggle(key)}
            />
            <span className="item-label">{LABEL[key]}</span>
          </li>
        </React.Fragment>
      ))}
      {hoverIdx === order.length && (
        <Placeholder
          toIdx={order.length}
          order={order}
          onMoveItem={onMoveItem}
          setHoverIdx={setHoverIdx}
        />
      )}
    </ul>
  );
}
